var map = {
  "./ar-SA.json": [
    "19878",
    "1851"
  ],
  "./tr-TR.json": [
    "48383",
    "6128"
  ],
  "./es-ES.json": [
    "68599",
    "2483"
  ],
  "./fr-FR.json": [
    "61471",
    "7124"
  ],
  "./EN.json": [
    "5471"
  ],
  "./pt-PT.json": [
    "18395",
    "4832"
  ],
  "./zh-CN.json": [
    "17792",
    "8521"
  ],
  "./ko-KR.json": [
    "42260",
    "8341"
  ],
  "./it-IT.json": [
    "389",
    "4822"
  ],
  "./de-DE.json": [
    "89053",
    "4438"
  ],
  "./ja-JP.json": [
    "27690",
    "4683"
  ],
  "./id-ID.json": [
    "83589",
    "1110"
  ],
  "./vi-VN.json": [
    "11572",
    "8685"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, 3 | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 41690;
module.exports = __rspack_async_context;
